import { supabase } from "./supabaseClient";

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,800;0,900;1,700;1,800&family=IBM+Plex+Sans:wght@300;400;500&family=IBM+Plex+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
html,body{height:100%;}
/* Theme variables defined globally in public/theme.css */
body{background:var(--bg);color:var(--text);font-family:var(--font-body);-webkit-font-smoothing:antialiased;}

.pending-page{
  min-height:100vh;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  background:var(--bg);
  position:relative;
  overflow:hidden;
  padding:2rem;
}
.pending-page::before{
  content:'';
  position:absolute;
  inset:0;
  background-image:linear-gradient(var(--border) 1px,transparent 1px),linear-gradient(90deg,var(--border) 1px,transparent 1px);
  background-size:60px 60px;
  mask-image:radial-gradient(ellipse 80% 80% at 50% 50%,black 30%,transparent 100%);
  pointer-events:none;
}
.pending-page::after{
  content:'';
  position:absolute;
  top:50%;left:50%;
  transform:translate(-50%,-50%);
  width:600px;height:400px;
  background:radial-gradient(ellipse,rgba(201,168,76,0.06) 0%,transparent 70%);
  pointer-events:none;
}

.pending-card{
  position:relative;
  z-index:1;
  width:100%;
  max-width:480px;
  background:var(--surface);
  border:1px solid rgba(201,168,76,0.2);
  border-radius:20px;
  padding:3rem 2.5rem;
  box-shadow:0 40px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(201,168,76,0.08);
  display:flex;
  flex-direction:column;
  align-items:center;
  text-align:center;
  gap:0;
}
.pending-card::before{
  content:'';
  position:absolute;
  top:0;left:10%;right:10%;
  height:1px;
  background:linear-gradient(90deg,transparent,var(--gold),transparent);
}

.pending-wordmark{
  font-family:var(--font-display);
  font-size:2rem;
  font-weight:900;
  letter-spacing:-0.03em;
  color:var(--text);
  margin-bottom:0.25rem;
}
.pending-wordmark em{font-style:italic;color:var(--gold);}
.pending-wordmark sup{font-family:var(--font-mono);font-size:0.5rem;color:var(--muted);vertical-align:super;}

.pending-tagline{
  font-family:var(--font-mono);
  font-size:0.62rem;
  color:var(--muted);
  letter-spacing:0.14em;
  text-transform:uppercase;
  margin-bottom:2.5rem;
}

.pending-icon{
  font-size:2.5rem;
  margin-bottom:1.25rem;
  opacity:0.8;
}

.pending-title{
  font-family:var(--font-display);
  font-size:1.4rem;
  font-weight:800;
  color:var(--text);
  margin-bottom:0.75rem;
  line-height:1.2;
}

.pending-text{
  font-size:0.88rem;
  color:var(--muted);
  line-height:1.7;
  margin-bottom:2rem;
  max-width:340px;
}

.pending-status{
  display:flex;
  align-items:center;
  gap:0.6rem;
  background:rgba(201,168,76,0.06);
  border:1px solid rgba(201,168,76,0.15);
  border-radius:100px;
  padding:0.45rem 1.1rem;
  font-family:var(--font-mono);
  font-size:0.65rem;
  color:var(--gold);
  letter-spacing:0.08em;
  margin-bottom:2rem;
}
.pending-status-dot{
  width:7px;
  height:7px;
  border-radius:50%;
  background:var(--gold);
  animation:pdot 2s infinite;
  flex-shrink:0;
}
@keyframes pdot{0%,100%{opacity:0.3}50%{opacity:1}}

.pending-signout{
  background:transparent;
  border:1px solid var(--border);
  border-radius:8px;
  padding:0.55rem 1.5rem;
  font-family:var(--font-mono);
  font-size:0.68rem;
  color:var(--muted);
  cursor:pointer;
  transition:all 0.18s;
  letter-spacing:0.08em;
}
.pending-signout:hover{border-color:var(--gold-dim);color:var(--gold);}

.pending-contact{
  margin-top:1.25rem;
  font-family:var(--font-mono);
  font-size:0.6rem;
  color:var(--muted);
  letter-spacing:0.06em;
}
.pending-contact a{color:var(--gold);text-decoration:none;}
.pending-contact a:hover{text-decoration:underline;}

/* ── LIGHT MODE OVERRIDES ── */
[data-theme="light"] body{background:#eef1f7;color:#1a1e2e;}
[data-theme="light"] .page,[data-theme="light"] .app,[data-theme="light"] .bt-app,[data-theme="light"] .tl-app,[data-theme="light"] .map-app,[data-theme="light"] .cf-app{background:#eef1f7;}
[data-theme="light"] .legisim-masthead{background:#1a2744;border-bottom-color:rgba(255,255,255,0.1);}
[data-theme="light"] .legisim-masthead::before{background:linear-gradient(90deg,transparent,var(--gold),transparent);}
[data-theme="light"] .masthead-wordmark{color:#e6e4dc;}
[data-theme="light"] .masthead-wordmark em{color:#c9a84c;}
[data-theme="light"] .masthead-wordmark sup{color:rgba(230,228,220,0.5);}
[data-theme="light"] .mast-back{border-color:rgba(201,168,76,0.6);color:#c9a84c;background:transparent;}
[data-theme="light"] .mast-back:hover{background:rgba(201,168,76,0.12);border-color:#c9a84c;color:#c9a84c;}
[data-theme="light"] .mast-btn-sm{color:#e6e4dc;border-color:rgba(201,168,76,0.4);}
[data-theme="light"] .mast-btn-sm:hover{color:#ffffff;border-color:#c9a84c;background:rgba(201,168,76,0.1);}
[data-theme="light"] .mast-btn-sm.signout:hover{border-color:rgba(192,57,43,0.7);color:#ff6b6b;background:rgba(192,57,43,0.1);}
[data-theme="light"] .sidebar,[data-theme="light"] .bt-left,[data-theme="light"] .cal-sidebar,[data-theme="light"] .cf-sidebar,[data-theme="light"] .map-left{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .main,[data-theme="light"] .bt-detail,[data-theme="light"] .cf-main{background:#eef1f7;}
[data-theme="light"] .filter-btn,[data-theme="light"] .vh-filter-btn{background:#f8f9fc;border-color:rgba(26,39,68,0.12);color:#6b7280;}
[data-theme="light"] .filter-btn.active,[data-theme="light"] .vh-filter-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .filter-btn.dem-active{background:var(--dem-bg);border-color:var(--dem);color:var(--dem);}
[data-theme="light"] .filter-btn.rep-active{background:var(--rep-bg);border-color:var(--rep);color:var(--rep);}
[data-theme="light"] .search-input,[data-theme="light"] .chat-input,[data-theme="light"] .bt-search-input,[data-theme="light"] .tl-search-input{background:#f8f9fc;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .leg-item.selected{background:#e8ecf4;}
[data-theme="light"] .leg-item.selected::before{background:#1a2744;}
[data-theme="light"] .leg-item:hover{background:#e8ecf4;}
[data-theme="light"] .chat-input-area{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .msg-bubble{background:#f0f2f8;border-color:rgba(26,39,68,0.1);}
[data-theme="light"] .msg.user .msg-bubble{background:#e8ecf4;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .send-btn{background:#1a2744;color:#f8f9fc;}
[data-theme="light"] .main-topbar,[data-theme="light"] .news-topbar,[data-theme="light"] .chamber-bar,[data-theme="light"] .toggle-bar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-header,[data-theme="light"] .vh-filters,[data-theme="light"] .vh-stats{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .vh-bill-number,[data-theme="light"] .bt-bill-number,[data-theme="light"] .bt-detail-number,[data-theme="light"] .tl-bill-number,[data-theme="light"] .district-num{color:#1a2744;}
[data-theme="light"] .profile-section-label,[data-theme="light"] .section-label,[data-theme="light"] .form-label,[data-theme="light"] .panel-title,[data-theme="light"] .output-label,[data-theme="light"] .floor-title,[data-theme="light"] .detail-title,[data-theme="light"] .search-section-label{color:#1a2744;}
[data-theme="light"] .input-panel{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .output-panel,[data-theme="light"] .output-body{background:#eef1f7;}
[data-theme="light"] .tl-add-btn,[data-theme="light"] .tl-refresh-btn,[data-theme="light"] .tl-view-btn{color:#1a2744;border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .tl-table-head{background:#e8ecf4;}
[data-theme="light"] .tl-tr:hover{background:#e8ecf4;}
[data-theme="light"] .date-group-header{color:#1a2744;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .detail-header,[data-theme="light"] .profile-header,[data-theme="light"] .donors-section,[data-theme="light"] .bt-detail-header{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .acct-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .news-tab.active{color:#1a2744;border-color:#1a2744;}
[data-theme="light"] .story-source{color:#6b7280;}
[data-theme="light"] .profile-sidebar{background:#f8f9fc;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .home-title{color:#1a2744;}
[data-theme="light"] .cf-amount,[data-theme="light"] .cf-total{color:#1a2744;}
[data-theme="light"] .chamber-btn.active{background:rgba(26,39,68,0.1);color:#1a2744;border-color:rgba(26,39,68,0.3);}
[data-theme="light"] .swing-chip{background:rgba(26,39,68,0.1);color:#1a2744;}
[data-theme="light"] .score-cell.pass{background:rgba(37,107,66,0.12);}
[data-theme="light"] .score-cell.fail{background:rgba(176,48,32,0.08);}
[data-theme="light"] .map-tooltip-district{color:#1a2744;}
[data-theme="light"] .watchlist-btn-small,[data-theme="light"] .watch-btn{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .vote-history-btn{background:rgba(160,120,48,0.08);border-color:rgba(160,120,48,0.35);color:#a07830;}
[data-theme="light"] .masthead-badge{background:rgba(26,39,68,0.08);border-color:rgba(26,39,68,0.2);}
[data-theme="light"] .masthead-badge-dot{background:#1a2744;}
[data-theme="light"] .mast-btn.gold{border-color:rgba(160,120,48,0.4);color:#a07830;}
[data-theme="light"] .mast-btn.active{background:rgba(26,39,68,0.1);border-color:rgba(26,39,68,0.3);color:#1a2744;}
[data-theme="light"] .issue-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .qp-btn{background:#f0f2f8;border-color:rgba(26,39,68,0.12);color:#6b7280;}
[data-theme="light"] .empty-card{background:#f0f2f8;border-color:rgba(26,39,68,0.12);}
[data-theme="light"] .donor-bar-fill{background:linear-gradient(90deg,#1a2744,#2d4a80);}
[data-theme="light"] .cf-leg-item.active,[data-theme="light"] .bt-bill-item.selected{border-left-color:#1a2744;}
[data-theme="light"] .subject-tag{background:#e8ecf4;border-color:rgba(26,39,68,0.12);color:#1a1e2e;}
[data-theme="light"] .plan-badge,[data-theme="light"] .admin{color:#1a2744;}
[data-theme="light"] .login-card{background:#f8f9fc;border-color:rgba(26,39,68,0.12);box-shadow:0 4px 24px rgba(26,39,68,0.1);}

@media(max-width:768px){
  .pending-card{width:90vw;padding:1.5rem;}
}`;

export default function PendingPage({ onNavigate, session }) {
  const handleSignOut = async () => {
    await supabase.auth.signOut();
    onNavigate("home");
  };

  return (
    <>
      <style>{CSS}</style>
      <div className="pending-page">
        <div className="pending-card">
          <div className="pending-wordmark">Whip<em>Count</em><sup>™</sup></div>
          <div className="pending-tagline">Michigan Legislative Intelligence</div>

          <div className="pending-icon">⏳</div>
          <div className="pending-title">Access Pending Approval</div>
          <div className="pending-text">
            Your account has been created successfully. A WhipCount team member will review your request and activate your access shortly.
          </div>

          <div className="pending-status">
            <div className="pending-status-dot" />
            AWAITING ACTIVATION
          </div>

          <button className="pending-signout" onClick={handleSignOut}>
            Sign Out
          </button>

          <div className="pending-contact">
            Questions? <a href="mailto:admin@whipcount.us">admin@whipcount.us</a>
          </div>
        </div>
      </div>
    </>
  );
}
